import AppComponent from '@AppComponent';
import {BrowserRouter} from 'react-router-dom';

export default function App() {
  return (
    <BrowserRouter>
      <AppComponent />
    </BrowserRouter>
  );
}
